module.exports = __webpack_public_path__ + "img/festival-faixa-inscrevase.f825304a.png";